import type { CandidateJourney, PriorityFlowPreview } from "./journeyTypes";

export function resolveSelectedFlowPath(
  paths: CandidateJourney[],
  flows: PriorityFlowPreview,
  requestedPathId: string | null | undefined,
): CandidateJourney | null {
  return (
    paths.find((path) => path.id === requestedPathId) ??
    flows.topLevel[0]?.representativePath ??
    null
  );
}

export function shouldReplaceFlowParam(
  requestedPathId: string | null | undefined,
  selectedPath: CandidateJourney | null,
): boolean {
  return Boolean(selectedPath && requestedPathId !== selectedPath.id);
}
